import { useComposeMessages } from "domains/message-component/hooks/useComposeMessages";

import { ComposeProps } from "../../types/Compose.types";
import { MessageEditor } from "./MessageEditor";
import { MessageEditorIdContext } from "./MessageEditorIdContext";
import { formatMessageTitle } from "./formatMessageTitle";

export const MessageEditors = ({
    assigneeLabel,
    assigneeSelector,
    setAssignee,
    patient,
    onUserTyping,
}: Pick<
    ComposeProps,
    | "assigneeLabel"
    | "assigneeSelector"
    | "setAssignee"
    | "patient"
    | "onUserTyping"
>) => {
    const {
        state: composeState,
        isMultipleMessages,
        dispatch,
    } = useComposeMessages();
    const messages = composeState.messages;

    return (
        <>
            {messages.map((message, i) => (
                // TODO: Find an ID - Index is chosen as id because these messages aren't submitted yet so they don't have an id. But if user removes a message, the id will be reused.
                <MessageEditorIdContext.Provider value={{ id: i }} key={i}>
                    <MessageEditor
                        onUserTyping={onUserTyping}
                        assigneeSelector={assigneeSelector}
                        assigneeLabel={assigneeLabel}
                        setAssignee={setAssignee}
                        patient={patient}
                        {...(isMultipleMessages
                            ? {
                                  showMultipleMessagesUi: true,
                                  editorTitle: formatMessageTitle(i, messages),
                                  onClickRemove: () =>
                                      dispatch({
                                          type: "REMOVE_MESSAGE",
                                          messageEditorId: i,
                                      }),
                              }
                            : { showMultipleMessagesUi: false })}
                    />
                </MessageEditorIdContext.Provider>
            ))}
        </>
    );
};
